import { render } from "./RotateAlert.vue?vue&type=template&id=2d9fa7c2&scoped=true"
import script from "./RotateAlert.vue?vue&type=script&lang=js"
export * from "./RotateAlert.vue?vue&type=script&lang=js"

import "./RotateAlert.vue?vue&type=style&index=0&id=2d9fa7c2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9fa7c2"]])

export default __exports__